import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';

const API = "/api";
const token = () => localStorage.getItem("token");

/**
 * Inicializa las notificaciones push: pide permiso, obtiene el token del
 * dispositivo, y lo registra en el backend. Se debe llamar después de
 * que el usuario inicia sesión (necesita el JWT para poder registrar el token).
 *
 * No hace nada si la app corre en un navegador normal (solo funciona
 * dentro de la app Android/iOS empaquetada con Capacitor).
 */
export async function inicializarNotificaciones() {
  if (!Capacitor.isNativePlatform()) {
    return; // estamos en el navegador normal, no en la app -> no aplica
  }

  try {
    let permiso = await PushNotifications.checkPermissions();

    if (permiso.receive === 'prompt') {
      permiso = await PushNotifications.requestPermissions();
    }

    if (permiso.receive !== 'granted') {
      console.log('Permiso de notificaciones no concedido');
      return;
    }

    await PushNotifications.register();

    PushNotifications.addListener('registration', async (tokenInfo) => {
      const deviceToken = tokenInfo.value;
      try {
        await fetch(`${API}/notificaciones/registrar-token`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
          body: JSON.stringify({ token: deviceToken, plataforma: Capacitor.getPlatform() }),
        });
        console.log('Token de notificaciones registrado correctamente');
      } catch (e) {
        console.error('No se pudo registrar el token de notificaciones', e);
      }
    });

    PushNotifications.addListener('registrationError', (err) => {
      console.error('Error registrando notificaciones push:', err);
    });

    // Notificación recibida con la app abierta (primer plano)
    PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('Notificación recibida:', notification);
    });

    // El usuario tocó la notificación
    PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      console.log('Notificación tocada:', action.notification);
      // Podríamos navegar a la pantalla de Créditos automáticamente acá si se quiere
    });
  } catch (e) {
    console.error('Error inicializando notificaciones push', e);
  }
}
